import IService from '../IService';

export default IService.extend({
  initialize: function () {
    this.$ajax = null;
  },

  post: function (TDM) {
    const promise = new $.Deferred();

    if (app.xhrExpected(this.$ajax)) {
      this.$ajax.abort();
    }

    this.$ajax = $.ajax({
      url: app.apiUrl('/api/v1/invitations'),
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify(TDM),
      type: 'POST',

      error: function (obj) {
        promise.reject({
          status: obj.status || 500,
          statuses: (obj.responseJSON && obj.responseJSON.statuses) || [],
        });
      },

      success: function (response) {
        promise.resolve(response);
      },
    }).always(() => {
      this.$ajax = null;
    });

    return promise;
  },
});
